import { MessageCircle, ArrowDown } from "lucide-react";
import { BRAND, buildWhatsAppUrl } from "../../lib/constants";
import { trackEvent } from "../../lib/api";

export default function FinalCTA() {
  const scrollToForm = () => {
    const el = document.getElementById("cotiza");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="contacto" data-testid="final-cta-section" className="relative text-white section-pad overflow-hidden" style={{ background: "linear-gradient(180deg, #1F2937 0%, #3D5311 100%)" }}>
      <div className="absolute inset-0 bg-grain pointer-events-none" />
      <div className="container-tight relative text-center md:text-left">
        <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
          <span className="divider-accent" />
          <span className="kicker-bright">Último llamado</span>
        </div>
        <h2 className="font-display font-black tracking-tightest text-4xl md:text-6xl lg:text-7xl leading-[0.95] max-w-5xl">
          Tu proyecto merece <span className="text-accent">arquitectura textil</span> de primer nivel.
        </h2>
        <p className="mt-8 max-w-2xl text-white/75 text-lg md:text-xl">
          20 años instalando México. Premio IFAI 2021. Cotización gratuita en menos de 24 horas.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
          <a
            href={buildWhatsAppUrl("Hola, vi la landing y quiero cotizar mi proyecto ahora mismo.")}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("cta_whatsapp_click", { location: "final_cta" })}
            className="btn-accent"
            data-testid="final-cta-whatsapp"
          >
            <MessageCircle className="w-4 h-4" /> Cotiza por WhatsApp ahora
          </a>
          <button
            onClick={scrollToForm}
            className="btn-outline"
            data-testid="final-cta-form"
          >
            <ArrowDown className="w-4 h-4" /> Llenar formulario de contacto
          </button>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row md:items-center gap-3 md:gap-6 text-white/70 font-mono text-xs md:text-sm">
          <span className="text-accent">{BRAND.phoneDisplay}</span>
          <span className="hidden md:inline text-white/30">·</span>
          <span>{BRAND.hours}</span>
          <span className="hidden md:inline text-white/30">·</span>
          <a href={`mailto:${BRAND.emailSales}`} className="hover:text-accent break-all">{BRAND.emailSales}</a>
        </div>
      </div>
    </section>
  );
}
